// extracted by mini-css-extract-plugin
module.exports = {"component":"reviews_component_1mEFI"};